import { useApi } from '../modules/api'
import { useAlert } from '../modules/composition/useAlert'

export const useSearch = async (endpoint, value, limit = 10, filter = null, sort = null) => {
	if (endpoint !== '' || value !== '') {
		let getParams = `${endpoint}/search?limit=${limit}&search=${value}`
		if (filter?.filterValue) getParams += `&role=${filter.filterValue}`
		if (sort) getParams += `&sort=${sort}`
		const { get, data, error } = useApi(getParams)

		await get()

		if (error.value) {
			useAlert().errorAlert(error.value?.message)
			return null
		}

		const map = {}

		data.value.forEach(({ id, surname, name, middleName }) => {
			map[id] = `${surname || ''} ${name} ${middleName || ''}`.trim()
		})

		return map
	}
}
